import { CONSTANT } from "@/util/ant_var";
import { Dropdown } from "antd";
import styled from "styled-components";

export const StyledDropdownButton = styled(Dropdown.Button)`
  padding-right: ${({ pr }) => pr};
  padding-left: ${({ pl }) => pl};
  margin-right: ${({ mr }) => mr};
  margin-left: ${({ ml }) => ml};
  display: ${({ display }) => display};
  .ant-btn {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
  }
  .ant-btn-default.ant-btn-color-default {
    border-color: ${CONSTANT.BUTTON_PRIMARY_BORDER};
  }
  .ant-btn-default.ant-btn-color-default {
    border-color: ${CONSTANT.BUTTON_DEFAULT_BORDER};
    background: ${CONSTANT.BUTTON_DEFAULT_BG};
    &:hover:not(:disabled) {
      background: ${CONSTANT.BUTTON_DEFAULT_BORDER} !important;
      border-color: ${CONSTANT.BUTTON_DEFAULT_BG} !important;
    }
  }
  .ant-btn-variant-solid:disabled {
    opacity: 0.5;
  }
  .table-view-dropdown {
    display: inline-flex;
    margin-left: 1rem;
    margin-right: 1rem;
  }
`;
